import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authenticatedFetch } from "../../network/api";
import "./payment.css";

export default function Return() {
  const { connectedAccountId } = useParams(); // Get connectedAccountId from URL params
  const navigate = useNavigate(); // For navigating to other pages
  const [loading, setLoading] = useState(false); // To show loading state
  const [error, setError] = useState(false); // To show error if the API call fails
  const [success, setSuccess] = useState(false); // To track if the update was successful

  useEffect(() => {
    if (!connectedAccountId) return; // If there's no connectedAccountId, do not proceed

    const updateOnboardingStatus = async () => {
      setLoading(true);
      setError(false);
      setSuccess(false);

      try {
        const response = await authenticatedFetch(
          "/api/attorney/webapp/updateOnboardingStatus",
          {
            method: "POST",
            body: JSON.stringify({
              stripe_account_id: connectedAccountId, // Send connectedAccountId to the API
            }),
          }
        );

        const data = await response.json();
        if (response.ok) {
          setSuccess(true); // If successful, set success state
        } else {
          setError(true); // If there's an error, set error state
        }
      } catch (err) {
        console.error("Error calling the API", err);
        setError(true); // If something goes wrong, set error state
      } finally {
        setLoading(false); // Stop loading after the request
      }
    };

    updateOnboardingStatus();
  }, [connectedAccountId]); // Run the effect when connectedAccountId changes

  // Button click to navigate to another page (for example, dashboard)
  const handleRedirect = () => {
    navigate("/attorney/settings"); // Change this to the desired route
  };

  return (
    <div className="container">
      <div className="banner">
        <h2>Quidpro</h2>
      </div>
      <div className="content">
        <h2>Details submitted</h2>
        <p>That's everything we need for now</p>

        {/* Show loading state */}
        {loading && <p className="loading-message">Loading...</p>}

        {/* Show success state */}
        {success && <p className="success-message">Onboarding status updated successfully!</p>}

        {/* Show error state */}
        {error && (
          <p className="error">Something went wrong! Please try again.</p>
        )}
      </div>

      {/* Button to navigate to another page */}
      <div>
        <button className="action-button" onClick={handleRedirect}>Go to Dashboard</button>
      </div>

      <div className="info-callout">
        <p>
          This is a sample app for Stripe-hosted Connect onboarding.{" "}
          <a
            href="https://docs.stripe.com/connect/onboarding/quickstart?connect-onboarding-surface=hosted"
            target="_blank"
            rel="noopener noreferrer"
          >
            View docs
          </a>
        </p>
      </div>
    </div>
  );
}
